<template>
    <div name="moisture" class="moisture">
        <div class="popup-bg" v-if="popupState > 0">
            <div class="popup" v-if="popupState == 1">
                <img class="close-btn" src="../assets/close.png" style="width: 24px" @click="popupOn(0)" />
                <span class="popup-title">처방 가능 보습제 안내</span>
                <div style="display: flex;">
                    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;margin-top: 20px;">
                        <div class="popup-box">
                            제로이드
                        </div>
                        <span class="popup-text1" style="margin-top: 16.3px;">
                            인텐시브 리치 MD 크림<br>
                            인텐시브 MD 크림<br>
                            인텐시브 MD 로션<br>
                            루트힐 모이스처라이저 MD<br>
                            써지엔젤 플러스 MD<br>
                            더마 쉴드 크림 MD
                        </span>
                        <div class="popup-box" style="margin-top: 25px;">
                            에스트라
                        </div>
                        <span class="popup-text1" style="margin-top: 16.3px;">
                            아토베리어 MD 크림<br>
                            아토베리어 MD 로션<br>
                            에스트라 MD 크림<br>     
                            아토베리어 잇칭 크림 MD<br>
                            더마베이비 PRO 크림 MD<br>
                            더마베이비 PRO 로션 MD<br>
                            아토베리어 AI MD 크림
                        </span>
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;margin-top: 20px;margin-left: 25px;">
                        <div class="popup-box">
                            셀퓨전씨
                        </div>
                        <span class="popup-text1" style="margin-top: 16.3px;">
                            엑스퍼트 배리덤 로션 MD<br>엑스퍼트 배리덤 크림 MD<br>엑스퍼트 배리덤 쉴드크림 MD

                        </span>
                        <div class="popup-box" style="margin-top: 25px;">
                            이지듀
                        </div>
                        <span class="popup-text1" style="margin-top: 16.3px;">
                            이지듀 MD 크림<br>이지듀 MD 로션<br>이지듀 MD 리젠 크림
                        </span>
                        <div class="popup-box" style="margin-top: 25px;">
                            그 외
                        </div>
                        <span class="popup-text1" style="margin-top: 16.3px;">
                            리쥬더마 아토 크림 MD<br>덱세릴 MD 크림
                        </span>
                    </div>
                </div>
            </div>
            <div class="popup" v-if="popupState == 2">
                <img class="close-btn" src="../assets/close.png" style="width: 24px" @click="popupOn(0)" />
                <span class="popup-title">당일배송 서비스 지역 안내</span>
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;margin-top: 20px;">
                    <div class="popup-box">
                        전 지역 서비스 가능한 지역 
                    </div>
                    <span class="popup-text1" style="margin-top: 11px;">
                        • 서울, 성남, 부천, 안양, 과천, 수원, 구리, 의왕, 군포
                    </span>
                    <div class="popup-box" style="margin-top: 17px;">
                        일부 지역 서비스 가능한 지역
                    </div>
                    <span class="popup-text1" style="margin-top: 11px;">
                        •<span class="popup-text2">인천광역시</span> : 부평구 / 계양구 / 미추홀구 / 남동구 간석동, 만<br>&nbsp;수동, 구월동<br>
                        •<span class="popup-text2">고양시</span> : 일산 서구 / 일산 동구 / 덕양구 화정동, 행신동, 강<br>&nbsp;매동, 덕은동, 도내동, 동산동, 삼송동, 성사동, 주교동, 지축<br>&nbsp;동, 토당동, 행주내동, 행주외동<br>
                        •<span class="popup-text2">광명시</span> : 광명1~5동, 철산1~4동, 하안2~4동, 소하1~2동,<br>&nbsp;일직동<br>
                        •<span class="popup-text2">남양주시</span> : 다산동, 별내동<br>
                        •<span class="popup-text2">안산시</span> : 상록구 / 단원구 고잔동, 목내동, 선부동, 성곡동, 신<br>&nbsp;길동, 와동, 원곡동, 원시동, 초지동<br>
                        •<span class="popup-text2">용인시</span> : 수지구<br>
                        •<span class="popup-text2">하남시</span> : 선동, 망월동, 감일동, 감이동, 학암동<br>
                        •<span class="popup-text2">화성시</span> : 능동, 반송동, 석우동, 영천동, 오산동, 청계동<br>

                    </span>
                </div>
            </div>

        </div>
        <span class="text1">보습제 라인업 <span style="font-weight: 600;">최다 보유</span></span>
        <span class="text2">보습제 MD</span>
        <span class="text3">비대면진료부터<br/>신속배송까지</span>
        <div class="bg-image">
            <img style="width: 100%" src="../assets/moistures.png" />
        </div>
        <div class="button-box" style="margin-top: 6x;">
            <img style="width: 24px;" src="../assets/info_fill.png" />
            <div class="right-box">
                <span class="box-text1">보습제MD 제품은 <span style="font-weight: 700;">택배로 수령 가능</span>합니다.</span>
                <div style="display: flex; margin-top: 11px;">
                    <button class="button" @click="popupOn(1)">처방 가능 보습제 확인</button>
                    <button class="button2" @click="popupOn(2)">당일배송 지역 확인</button>
                </div>
            </div>
        </div>
        <div class="button-box" style="margin-top: 10px;">
            <img style="width: 24px; " src="../assets/info_fill.png" />
            <div class="right-box">
                <span class="box-text1">처방전, 진료 확인서 등 진료 서류도<br> 솔닥에서 <span style="font-weight: 700;">바로 발급</span> 가능합니다.</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'moisture',
    data: function(){
        return {
            popupState: 0
        }
    },
    methods: {
        popupOn: function(state) {
            this.popupState = state;
        }
    }
}
</script>

<style scoped>
    .moisture {
        width: 100%;
        background: #F8F8F8;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 75px 20px;
    }

    .popup-bg{
        position: absolute;
        background: rgba(17, 0, 0, 0.66);
        height: 100%;
        width: calc(100% + 40px);
        margin-left: -40px;
        z-index: 20;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .popup {
        width: calc(100% - 60px);
        height: auto;
        border-radius: 10px;
        background: #FFF;
        position: fixed;
        top: 50%;
        transform: translate(0, -50%);
        padding-top: 17px;
        padding-left: 19px;
        padding-bottom: 28px;
        display: flex;
        flex-direction: column;

    }

    .close-btn {
        position: absolute;
        top:  13px;
        right: 18px;
        cursor:pointer;
    }

    @media (min-width: 960px) {
        .popup {
            width: 315px;
            height: auto;
            border-radius: 10px;
            background: #FFF;
            position: fixed;
            top: 50%;
            transform: translate(0, -50%);

        }
    }

    .text1{
        color: #666;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text2{
        margin-top: 12px;
        color: #000;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 126.667% */
    }
    .text3{
        color: #008DEF;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px;
    }
    .bg-image {
        width: calc(100% - 51.2px);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 64px;
    }
    .button-box {
        border-radius: 10px;
        background: #FFF;
        /* padding: 20.48px 55.04px 24.32px 21.76px;  */
        flex-shrink: 0;
        width: calc(100% - 51.2px);
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding-top: 20.48px;
        padding-bottom: 24.32px;
        padding-left: 17px;
        position: relative;
    }
    .right-box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 12.8px;
    }

    .box-text1 {
        color: #1A1A1A;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    .button {
        display: flex;
        padding: 6.4px 14.08px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #008DEF;
        background: #FFF;
        color: #008DEF;

        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
        cursor: pointer;
    }
    .button2 {
        display: flex;
        padding: 6.4px 14.08px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #DFDFDF;
        background: #F6F6F6;
        color: #000;

        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
        margin-left: 3px;
        cursor: pointer;
    }

    .popup-title {
        color: #1A1A1A;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 19px; /* 105.556% */
    }

    .popup-box {
        display: flex;

        padding: 6px 20px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        color: #008DEF;
        text-align: center;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px; /* 141.667% */
        border-radius: 32px;
        background: #E5F0FC;
    }
    .popup-text1{
        color: #666;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 158.333% */
    }

    .popup-text2{
        color: #666;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 19px; /* 158.333% */
    }
</style>


// WEBPACK FOOTER //
// src/components/Moisture.vue